module.exports = __webpack_public_path__ + "static/media/RADIONOVELA.2ed5ee2c.jpg";